import Layout from "../../components/layout";
import {GetStaticProps} from "next";
import Link from "../../components/Link";
import React, {useState} from "react";
import Dialog from "../../components/v2/dialog";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import nextI18NextConfig from "../../next-i18next.config";
import '../../styles/scss/_events-page.module.scss';

export default function ObservabilityMeetupAhmedabad({ props }) {
    const { t } = useTranslation('common');
    const pageData = t('resources.events.pages.observabilityMeetupAhmedabad2025', { returnObjects: true, defaultValue: {} }) as any;
    
    const heroData = pageData?.hero || {};
    const contentData = pageData?.content || {};
    const speakersSectionData = contentData?.speakersSection || {};
    
    // Helper function to safely convert to string (handles objects)
    const safeString = (value: any): string => {
        if (value === null || value === undefined) return '';
        if (typeof value === 'string') return value;
        if (typeof value === 'object') {
            if (value.text) return String(value.text);
            if (value.value) return String(value.value);
            if (value.label) return String(value.label);
            return '';
        }
        return String(value);
    };
    
    const [imgOpen, setImgOpen] = useState(false);
    const [imgUrl, setImgUrl] = useState("");

    function isImageOpen(s: string) {
        setImgOpen(true)
        setImgUrl(s)
    }

    return(
        <>
            <Layout isHomePage={false} pageTitle={String(pageData?.pageTitle ?? '')}
                    ogImage={String(pageData?.ogImage ?? '')}
                    uri={String(pageData?.uri ?? '')}
                    metaTitle={String(pageData?.metaTitle ?? '')}
                    metaDesc={String(pageData?.metaDesc ?? '')}
                    metaRobotsNoindex={String(pageData?.metaRobotsNoindex ?? '')}
                    metaRobotsNofollow={String(pageData?.metaRobotsNofollow ?? '')}>

                <div className={'global-wrapper'} >
                    <div className={"event-page dine-with-devops"}>
                        <section className={'hero-section'}>
                            <div className={'container'}>
                                <div className={'d-flex'}>
                                    <div className={'left-block'}>
                                        <Link href={String(heroData?.backLinkUrl ?? '/events/')} className={"back-to-blog"}>{String(heroData?.backLink ?? '')}</Link>
                                        {heroData?.logo && (
                                            <div className={'d-flex aws-mw'}>
                                                <img src={safeString(heroData.logo?.src)} alt={safeString(heroData.logo?.alt)} className={'aws-logo'} width={"100%"} height={"100%"}/>
                                            </div>
                                        )}
                                        <div className={'inner-hero'}>
                                            <h1>
                                                {safeString(heroData?.titlePrefix ?? '')}
                                                <span>{safeString(heroData?.titleHighlight ?? '')}</span>
                                                {safeString(heroData?.titleMiddle ?? '')}
                                                <span>{safeString(heroData?.titleHighlight2 ?? '')}</span>
                                                {safeString(heroData?.titleSuffix ?? '')}
                                            </h1>
                                            {heroData?.date && <p><b>Date: </b>{safeString(heroData.date)}</p>}
                                            {heroData?.time && <p><b>Time: </b>{safeString(heroData.time)}</p>}
                                            {heroData?.venue && <p><b>Venue: </b>{safeString(heroData.venue)}</p>}
                                        </div>
                                    </div>
                                    <div className={'right-block'}>
                                        <img
                                            src={String(heroData?.image?.src ?? '')} alt={String(heroData?.image?.alt ?? '')} width={"100%"} height={"100%"}/>
                                    </div>
                                </div>

                            </div>
                        </section>
                        <section className={'content-section'}>
                            <div className={'container'}>
                                <div className={'left-block sm-width'}>
                                    <p>{String(contentData?.description ?? '')}</p>
                                    
                                    {contentData?.hasSpeakers && speakersSectionData && (
                                        <>
                                            <h4>{String(speakersSectionData?.title ?? '')}</h4>
                                            {Array.isArray(speakersSectionData?.speakers) && speakersSectionData.speakers.map((speaker: any, index: number) => (
                                                <React.Fragment key={index}>
                                                    <p><b>{String(speaker?.name ?? '')}, {String(speaker?.role ?? '')}: {String(speaker?.topic ?? '')}</b></p>
                                                    {speaker?.bio && (
                                                        <p>{String(speaker.bio)}</p>
                                                    )}
                                                </React.Fragment>
                                            ))}
                                            {speakersSectionData?.registerLink && (
                                                <p>
                                                    {String(speakersSectionData?.registerText ?? '')} 
                                                    <Link href={String(speakersSectionData.registerLink)} target={"_blank"}>{String(speakersSectionData.registerLink)}</Link>
                                                </p>
                                            )}
                                            {speakersSectionData?.note && (
                                                <p><i><b>{String(speakersSectionData.note)}</b></i></p>
                                            )}
                                            {speakersSectionData?.closingText && (
                                                <p>{String(speakersSectionData.closingText)}</p>
                                            )}
                                        </>
                                    )}
                                </div>

                                {Array.isArray(speakersSectionData?.eventImages) && speakersSectionData.eventImages.length > 0 && (
                                    <div className={"img-group-event"}>
                                        {speakersSectionData.eventImages.map((image: any, index: number) => (
                                            <img key={index} src={String(image?.src ?? '')} alt={String(image?.alt ?? '')} width={100} height={100} onClick={() => isImageOpen(String(image?.src ?? ''))} />
                                        ))}
                                    </div>
                                )}

                            </div>
                        </section>
                    </div>
                </div>

                <Dialog
                    isOpen={imgOpen}
                    position={"center"}
                    onClose={() => {
                        setImgOpen(false);
                        setImgUrl("")
                    }}
                    size={"sm"}
                    verticalCenter={true}
                >
                    <div
                        style={{
                            position: "relative",
                            width: "100%",
                            aspectRatio: "16/9",
                            backgroundColor: "#000",
                        }}
                    >
                        <img src={imgUrl} alt={"Dialog Image"} width={100} height={100}/>
                    </div>
                </Dialog>


            </Layout>
        </>
    )
}

export const getStaticProps: GetStaticProps = async (ctx) => {
  const translations = await serverSideTranslations(
    ctx?.locale ?? "en",
    ["common", "header", "footer"],
    nextI18NextConfig,
  );
    return {
        props: {
            ...translations,
            pageTitle: "Observability Meetup Ahmedabad presented by Middleware",
            description:"Middleware is hosting an Observability Meetup - Ahmedabad on 19th April 2025 in collaboration with Hashicorp User Group Ahmedabad.",
            ogImage: "/images/events/observability-meetup-ahmedabad-2025.jpg",
            uri:"/events/observability-meetup-ahmedabad-2025/",
            metaTitle:"Observability Meetup Ahmedabad presented by Middleware",
            metaDesc:"Middleware is hosting an Observability Meetup - Ahmedabad on 19th April 2025 in collaboration with Hashicorp User Group Ahmedabad.",
            metaRobotsNoindex:"index",
            metaRobotsNofollow:"follow",
        },
    }
}

